import React from 'react';
import { IElementListItem } from '../api';
import { COURSE_ITEM_TYPE } from '../enum';
import { LearnStatusIconMap } from '../constant';
import LockedImg from '../image/locked.png';
import { getBool } from '../util';

interface IProps {
    item: IElementListItem;
}
export const LeftIcon = (props: IProps) => {
    const { item } = props;
    const { item_type, lock, extend, chapter_completion } = item;

    const isLock = getBool(item_type == COURSE_ITEM_TYPE.CHAPTER ? lock : extend.lock);
    const learnStatus =
        item_type == COURSE_ITEM_TYPE.CHAPTER ? chapter_completion.completion_status : extend.learn_status;

    let img = isLock ? LockedImg : '';
    if (!img) {
        img = LearnStatusIconMap[learnStatus];
    }

    return (
        <div className="left-icon">
            <img src={img} alt="" />
        </div>
    );
};
